module.exports = __webpack_public_path__ + "assets/ArrowDown.15b8f3c583bab2448274b77d9573b7f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/user-menu/ArrowDown.svg
// module id = 874
// module chunks = 0